import React from 'react';
import PropTypes from 'prop-types';
import {
  Tile,
  TileContent,
  TileGroup,
  TileMedia,
  TileText
} from '@one-thd/sui-atomic-components';
import { isRefinementActive } from '../../product-results-helpers';

const VisualRefinement = ({
  dimension, onChange, refinements, dimensionId, selectedRefinements
}) => {

  const handleTileSelection = (_event, refinement) => {

    if (onChange) {
      onChange({ refinement, dimension });
    }
  };

  const getProductImageUrl = (imgUrl) => {
    const PRODUCT_CATALOG_IMAGE_PATH = 'https://images.homedepot-static.com/productImages';
    const SIZE = '100';

    if (Number(imgUrl) === 1 || !imgUrl) {
      return `https://images.homedepot-static.com/catalog/productImages/No_Image_${SIZE}.jpg`;
    }

    const cleanedImgUrl = imgUrl.trim();
    return `${PRODUCT_CATALOG_IMAGE_PATH}/${cleanedImgUrl}/svn/${cleanedImgUrl}_${SIZE}.jpg`;
  };

  return (
    <TileGroup
      value={selectedRefinements ? selectedRefinements.map((ref) => ref.label) : []}
      disableExclusive
      className="sui-grid sui-grid-cols-2 md:sui-grid-cols-3 sui-gap-3"
      key={dimensionId}
      data-instoredisplay="true"
      data-testid="visual-refinement-card"
    >
      {refinements.map((refinement) => {
        const { imgUrl, label, refinementKey } = refinement || {};
        const isRefinementSelected = isRefinementActive(
          refinement.refinementKey,
          selectedRefinements
        );
        return (
          <div key={refinementKey}>
            {/* SEO-friendly hidden link - Required for SEO significance. Reach out to SEO team if wanting to change */}
            <a
              href={refinement.url}
              className="sui-hidden"
              aria-hidden="true"
              tabIndex="-1"
            >
              {/* H3 element required for SEO significance. Reach out to SEO team if wanting to change */}
              <h3>{label}</h3>
            </a>
            <Tile
              value={refinement.label}
              aria-label={refinement.label}
              data-refinement={refinement.label}
              data-refinementvalue={refinement.label}
              style={{ maxWidth: '136px', height: '100%' }}
              selected={isRefinementSelected}
              onChange={(event) => handleTileSelection(event, refinement)}
            >
              <TileContent orientation="vertical" alignItems="start">
                <TileMedia className="sui-h-[118px]" src={getProductImageUrl(imgUrl)} />
                <TileText align="left" lineClamp="2">{label}</TileText>
              </TileContent>
            </Tile>
          </div>
        );
      })}
    </TileGroup>
  );
};

VisualRefinement.propTypes = {
  dimension: PropTypes.shape({
    dimensionId: PropTypes.string,
    label: PropTypes.string,
    refinements: PropTypes.arrayOf(
      PropTypes.shape({})
    )
  }).isRequired,
  refinements: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      refinementKey: PropTypes.string,
      selected: PropTypes.bool,
      url: PropTypes.string,
      id: PropTypes.string,
      imgUrl: PropTypes.string
    })
  ),
  onChange: PropTypes.func.isRequired,
  dimensionId: PropTypes.string,
  selectedRefinements: PropTypes.arrayOf(PropTypes.shape({}))
};

VisualRefinement.defaultProps = {
  refinements: [],
  dimensionId: '',
  selectedRefinements: []
};

VisualRefinement.displayName = 'VisualRefinement';

export { VisualRefinement };
